<template>
  <div>
    <div>
      <!-- <el-input
        style="width: 200px"
        placeholder="输入查找年份"
        v-model="logYear"
      ></el-input> -->
      <el-input
        style="width: 200px"
        placeholder="输入查找信息"
        v-model="search"
      ></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
      <!-- <el-button @click="exportStateTotal" type="warning">导出</el-button> -->
      <!-- <el-button type="primary" icon="el-icon-magic-stick" @click="dialogVisible=true">查看统计图</el-button> -->
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" border>
        <el-table-column align="center" label="登录名" prop="userName">
          <!-- <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>用户名: {{ scope.row.username }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.username }}</el-tag>
              </div>
            </el-popover>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="真实名称" prop="realName">
          <!-- <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.usertype }}</span>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="医院名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.hospitalName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="年份" prop="logYear">
          <!-- <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>应用名: {{ scope.row.appName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="success" size="medium">{{
                  scope.row.appName
                }}</el-tag>
              </div>
            </el-popover>
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="系统名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.systemName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="年份">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.intyear }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="一月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.oneMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="二月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.twoMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="三月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.threeMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="四月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.fourMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="五月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.fiveMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="六月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sixMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="七月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sevenMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="八月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.eightMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="九月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.nineMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.tenMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十一月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.elevenMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十二月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.twelveMonth }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="本年">
          <template slot-scope="scope">
            <span style="margin-left: 10px">
              {{
                scope.row.twelveMonth +
                scope.row.elevenMonth +
                scope.row.oneMonth +
                scope.row.tenMonth +
                scope.row.nineMonth +
                scope.row.eightMonth +
                scope.row.sevenMonth +
                scope.row.sixMonth +
                scope.row.fiveMonth +
                scope.row.fourMonth +
                scope.row.threeMonth +
                scope.row.twoMonth
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog
      title="查看统计图"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div>
        <el-select v-model="typeValue" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <span>内容开发。。。</span>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  filters: {
    filterUesrType(val) {
      var statusTxet = [
        "其他",
        "职工",
        "住培学员",
        "研究生",
        "实习生",
        "进修生",
      ];
      return statusTxet[val];
    },
  },
  mounted() {
    this.load();
  },

  data() {
    return {
      dialogVisible: false,
      search: "",
      logYear: "", //当前年
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      typeList: [],
      typeValue: "",
    };
  },
  methods: {
    exportStateTotal() {
      this.$api.exportStateTotalLogin(
        this.search,
        this.logYear,
        "Bearer " + sessionStorage.getItem("access_token")
      );
      // window.open(process.env.VUE_APP_API_URL+'/login-log/export?search='+this.search+'&startTime='+this.startTime+'&endDate='+this.endDate,'_self')
      // this.$api.exportStateLogin(obj).then(res=>{
      //   console.log(res)
      //   const blob = new Blob([res.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}) // 处理文档流（res.data为返回的文档流）
      //   const fileName = '登录统计' // 下载时的文件名
      //   const elink = document.createElement('a')
      //   elink.download = fileName
      //   elink.style.display = 'none'
      //   elink.href = URL.createObjectURL(blob)
      //   document.body.appendChild(elink)
      //   elink.click()
      //   URL.revokeObjectURL(elink.href) // 释放URL 对象
      //   document.body.removeChild(elink)
      // }).catch(er=>{console.log(er)})
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.search,
        logYear: this.logYear,
      };
      if (obj.search) {
        obj.pageNo = 1;
      } else {
        obj.pageNo = this.page;
      }

      console.log(obj);

      this.$api.foreignloginState(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          // this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
        let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.search,
        logYear: this.logYear,
      };

      this.$api.foreignloginState(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>